<h3 class=" text-event text-gray-700 text-center text-lg justify-center mb-3">{{ (title || 'words.untitled') | translate }}</h3>
<div class="empty__state rounded">
    <div class="state__icon relative mb-4">
        <img src="https://static.myskillcamp.com/images/empty-states/shape.svg" alt="empty" *ngIf="!hasPicture">
        <img [src]="source" alt="empty" *ngIf="hasPicture">
        <i [class]="'absolute top-1/4 left-1/4 icon ' + source" *ngIf="!hasPicture"></i>
    </div>

    <p class="my-2 hidden">{{ (title || 'words.untitled') | translate }}</p>
    <span class="text-gray-700 text-md ">{{ description | translate }}</span>
</div>
